<!-- Step 1: DNI -->
<ng-container *ngIf="step === 'dni'">
  <div class="card">
    <div class="dni-field">
      <label for="dni">{{ 'dniStepTitle' | translate }}</label>
      <input id="dni" type="text" [(ngModel)]="dni" [placeholder]="'enterDni' | translate" maxlength="20" />
    </div>
  </div>

  <button class="btn btn-primary btn-centered btn-w-100" (click)="goToSignStep()" [disabled]="!dni.trim()">
    <span>{{ 'continue' | translate }}</span>
    <mat-icon>arrow_right_alt</mat-icon>
  </button>
</ng-container>

<!-- Step 2: Signature -->
<ng-container *ngIf="step === 'sign'">
  <div class="card">
    <div id="pad">
      <div class="signature-placeholder" *ngIf="signaturePad==null || signaturePad.isEmpty()">
        <mat-icon>draw</mat-icon>
        <span>{{ 'signHere' | translate }}</span>
      </div>
      <signature-pad #signature [options]="signaturePadOptions"></signature-pad>
    </div>

    <div id="controls">
      <button class="btn btn-icon btn-primary btn-outline" id="drawer">
        <mat-icon>draw</mat-icon>
      </button>
      <button class="btn btn-icon btn-primary btn-outline" id="eraser" (click)="erase()">
        <mat-icon>delete</mat-icon>
      </button>
      <mat-slider [disableRipple]="true" [min]="1" [max]="10">
        <input matSliderThumb [(ngModel)]="strokeWidth">
      </mat-slider>
    </div>
  </div>

  <button class="btn btn-primary btn-centered btn-w-100" (click)="sign()" [disabled]="signaturePad==null || signaturePad.isEmpty()">
    <span>{{ 'sendSignature' | translate }}</span>
    <mat-icon>arrow_right_alt</mat-icon>
  </button>
</ng-container>
